import { Component, Input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common'; // Import CommonModule

@Component({
  selector: 'app-expansion-panel',
  standalone: true,
  imports: [MatExpansionModule, MatIconModule, CommonModule], // Add CommonModule to imports
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.css']
})
export class ExpansionPanelComponent {
  @Input() title: string = ''; 
  @Input() description: string = '';
  @Input() isTitleBold: boolean = true;

  @Input() isDefaultOpen: boolean = true;
  
  public panelOpenState:boolean;

  constructor() {
    this.panelOpenState = this.isDefaultOpen;
  }


  togglePanel() {
    this.panelOpenState = !this.panelOpenState;
  }
}
